import * as React from 'react';
import * as A11yDialog from 'a11y-dialog';

// Figure out best way to import these modules.
const Swiper = require('swiper').default;

import ModalCarouselComponent from './modal-carousel';
import { IMediaGalleryItem, MediaGalleryItemType, IMediaGalleryImage } from '../../classes/media-gallery';
import { MediaGalleryAppState } from '../../classes/index';
import { connect, Dispatch } from 'react-redux';
import { findDOMNode } from 'react-dom';

interface StateToProps {
    media: IMediaGalleryItem;
}

type ModalContentProps = StateToProps;

class ModalContentComponent extends React.Component<ModalContentProps, null> {

    constructor(props: ModalContentProps) {
        super(props);
    }

    render() {
        return (
            <div className="modal-content">
                <ModalCarouselComponent mediaItem={this.props.media} />

                <dl className="data-list">
                    <dt>Season</dt>
                    <dd>{this.props.media ? this.props.media.seasonTag : ""}</dd>

                    <dt>Production</dt>
                    <dd>{this.props.media ? this.props.media.productionName : ""}</dd>
                </dl>
            </div>
        );
    }
}

function mapStateToProps(state: MediaGalleryAppState): StateToProps {
    return {
        media: state.modalModel.content
    }
}

export default connect<StateToProps>(mapStateToProps)(ModalContentComponent);


// WEBPACK FOOTER //
// ./app/media-gallery/components/modal-content.tsx